<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    min-width="230"
    content-class="user-profile-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        bottom
        color="success"
        overlap
        offset-x="12"
        offset-y="12"
        class="ms-4"
        dot
      >
        <v-avatar
          size="40px"
          v-bind="attrs"
          v-on="on"
        >
          <img 
            class="profile-img"
            :src="$assetUrl(userProfileImg)" 
          />
        </v-avatar>
      </v-badge>
    </template>
    <v-list>
      <div class="pb-3 pt-2">
        <v-badge
          bottom
          color="success"
          overlap
          offset-x="12"
          offset-y="12"
          class="ms-4"
          dot
        >
          <v-avatar size="40px">
            <img 
              class="profile-img"
              :src="$assetUrl(userProfileImg)" 
            />
          </v-avatar>
        </v-badge>
        <div
          class="d-inline-flex flex-column justify-center ms-3"
          style="vertical-align:middle"
        >
          <span class="text--primary font-weight-semibold mb-n1">
            {{user_Name}}
          </span>
          <small class="text--disabled text-capitalize">{{user_designation}}</small>
        </div>
      </div>

      <v-divider></v-divider>

      <!-- Profile -->
      <v-list-item link>
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiAccountOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content @click="profile()">
          <v-list-item-title>Profile</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Logout -->
      <v-list-item link>
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiLogoutVariant }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content @click="signout()">
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { baseUrl, apiUrl, assetUrl } from '@/config/config'

import {
  mdiAccountOutline,
  mdiEmailOutline,
  mdiCheckboxMarkedOutline,
  mdiChatOutline,
  mdiCogOutline,
  mdiCurrencyUsd,
  mdiHelpCircleOutline,
  mdiLogoutVariant,
} from '@mdi/js'

export default {
  data(){
    return{
      userProfileImg : "",
      user_Name : "",
      user_designation : "",
    }
  },
  setup() {
    return {
      icons: {
        mdiAccountOutline,
        mdiEmailOutline,
        mdiCheckboxMarkedOutline,
        mdiChatOutline,
        mdiCogOutline,
        mdiCurrencyUsd,
        mdiHelpCircleOutline,
        mdiLogoutVariant,
      },
    }
  },

  async mounted() {
    this.localDataCheck()
  },

  methods: {

    localDataCheck(){
      if(localStorage.getItem("token") != null){
        const localStoragedata = JSON.parse(localStorage.getItem("token"))
        this.user_Name = localStoragedata.user_name
        this.userProfileImg = localStoragedata.profilePicture
        this.user_designation = localStoragedata.userDesignation
      }if(this.userProfileImg == null || this.userProfileImg == ''){
        this.userProfileImg = "uploads/default_image/default_image.png"
      }
    },

    async profile(){
      this.$router.push({name:'pages-account-settings'}); 
    },

    signout() {
      // localStorage.clear()
      localStorage.removeItem("token");
      this.$cookies.remove("login");
      // this.$router.go('/')
      window.location.href ='/'
    },
  },

}
</script>

<style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}
.profile-img{
  width: 100%; 
  height: 100%; 
  object-fit: cover;
}
</style>
